import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

let Slider = {};

Slider.initSwiper = (object, params = {}) => {
	return new Swiper(object, {
		modules: [Navigation, Pagination, EffectFade],
		slidesPerView: 1,
		loop: false,
		...params,
	});
};

// Sliders Mobile
let mq = 768;
let sliders_mobile = document.querySelectorAll(".slider-mobile .swiper");
let swiperMobile = null;
let init = false;

const sliderMobile = () => {
	if (window.innerWidth <= mq) {
		if (!init) {
			init = true;
			swiperMobile = new Swiper(".slider-mobile .swiper", {
				modules: [Pagination],
				slidesPerView: 1,
				spaceBetween: 16,
				pagination: {
					el: ".slider-mobile-pagination",
					type: "bullets",
					clickable: true,
				},
			});
		}
	} else {
		if (init && swiperMobile) {
			swiperMobile.destroy(true, true); // Détruit proprement Swiper
			swiperMobile = null; // Réinitialise l'instance pour éviter les erreurs
			init = false;
		}
	}
};

// Vérifier s'il y a des sliders à initialiser
if (sliders_mobile.length > 0) {
	sliderMobile();
	window.addEventListener("resize", sliderMobile);
}

export default Slider;
